export default __webpack_public_path__ + "static/media/2.add590ea.jpg";